import apiPath from '@/lib/apiPath';
import request from '@/lib/request';
import { rootStore } from '@/store/rootStore';
import { removeToken } from '@/lib/token';
import { ElMessage } from 'element-plus';
import { router } from '@/router';
import { appStore } from '@/lib/appStore';
const isProd = !/sandbox|localhost|127\.0.0.1/i.test(location.hostname);

let hasSdk = false;

const initQASdk = (userInfo) => {
  const url = isProd ? '//ai-resource-admin.seeronnet.com' : '//sandbox-ai-resource-admin.seeronnet.com';
  const platform_id = '157302467900000021';
  const unify_user_id = userInfo.id;
  const iframeUrl = `${url}/api/pub/getQaUrl?platform_id=${platform_id}&unify_user_id=${unify_user_id}&from=iframe`;
  if (typeof window?.qaSDKInstance?.init === 'function') {
    window.qaSDKInstance.init(iframeUrl, {
      ballPosition: {
        bottom: 200,
      },
      welPopupDelayTime: 2000,
    });
    hasSdk = true;
  }
};

// 用户信息变化事件
export const handleUserInfoChange = async (res) => {
  const store = rootStore();
  if (isProd) {
    // if (!hasSdk) initQASdk(res);
    if (window.platformData) {
      window.platformData.init({
        platform_user_id: res.id,
        platform_id: 'seeronnet-shield',
      });
    }
    // // 性能埋点
    // if (window.LINGHIT_APM_SDK) {
    //   window.LINGHIT_APM_SDK.init({
    //     centerUserId: res.id,
    //     appId: 'M115',
    //   });
    // }
  }
  store.setUserInfo(res);
  if (res?.is_manager) {
    updateUserList();
  }
};

export const getUserInfo = async () => {
  const store = rootStore();
  if (store.userName) {
    return;
  }
  const res = await request.get(apiPath.base.userInfo);

  appStore.setVerificationStatus(true);
  handleUserInfoChange(res);

  return res;
};

export const getUserInfoByAuthCode = async (data) => {
  const store = rootStore();
  if (store.userName) {
    return;
  }
  const res = await request.post(apiPath.base.userInfoByAuthCode, data);

  handleUserInfoChange(res);

  return res;
};

export const logout = (query = '') => {
  removeToken();
  ElMessage.success('账号已登出');
  // 清除 app 选择缓存
  appStore.clearAppSelection();
  setTimeout(() => {
    router.replace('/loginV2' + query);
  }, 1000);
};

const updateUserList = async () => {
  const store = rootStore();
  const res = await request.get(apiPath.admin.userList);
  store.setUserList(res);
  return res;
};
